

 export default class toast {
    static showToast = function(variant, message) {
        window.postMessage({type: "toast", open: true, message: message, variant: variant})
    }

    static success = function(message) {
        toast.showToast("success", message)
    }

    static info = function(message) {
        toast.showToast("info", message)
    }

    static warning = function(message) {
        toast.showToast("warning", message)
    }

    static error = function(message) {
        toast.showToast("error", message)
    }
}  
